<template>
  <tracks-list :tracks="allTracks" :loading="loading" @play="setPlaylist(allTracks)"></tracks-list>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TracksList from './TracksList.vue'

  export default {
    name: 'all-tracks-list',
    components: {
      TracksList
    },
    created () {
      this.setFrom(0)
      this.getAll().catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    },
    computed: {
      ...mapGetters('track', [
        'allTracks'
      ]),
      loading () {
        return this.$loading.isLoading('track getAll')
      }
    },
    methods: {
      ...mapActions('track', [
        'getAll',
        'setFrom'
      ]),
      ...mapActions('player', [
        'setPlaylist'
      ])
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/tracks/AllTracksList.vue